import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=584f0d5d&scoped=true&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=584f0d5d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f0d5d",
  null
  
)

export default component.exports